"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const auth0_react_1 = require("@auth0/auth0-react");
const apiUtils_1 = require("../util/apiUtils");
const auth_1 = require("../util/auth");
const sendFile = async ({ apiURL, formData, setMessage, getAccessTokenSilently, getAuthHeader, loginWithRedirect, }) => {
    try {
        let accessToken;
        try {
            accessToken = await (0, auth_1.getAccessToken)(getAccessTokenSilently);
        }
        catch (error) {
            if ((0, auth_1.shouldTriggerLoginRedirect)(error)) {
                loginWithRedirect();
                return false;
            }
            throw error;
        }
        const authHeader = getAuthHeader(accessToken);
        const headers = {
            ...authHeader,
        };
        const response = await fetch((0, apiUtils_1.getAPIUrl)() + apiURL, {
            method: "POST",
            body: formData,
            headers,
        });
        if ((0, auth_1.shouldTriggerLoginRedirect)(undefined, response.status)) {
            loginWithRedirect();
            return false;
        }
        if (response.ok) {
            setMessage("File uploaded successfully!");
            return true;
        }
        else {
            setMessage("File upload failed.");
            return false;
        }
    }
    catch (error) {
        if ((0, auth_1.shouldTriggerLoginRedirect)(error)) {
            loginWithRedirect();
            return false;
        }
        setMessage("Error uploading file.");
        console.error(error);
        return false;
    }
};
exports.default = (apiURL) => {
    const [message, setMessage] = (0, react_1.useState)();
    const { getAuthHeader, getAccessTokenSilently } = (0, auth_1.useAuthentication)();
    const { loginWithRedirect } = (0, auth0_react_1.useAuth0)();
    const send = (0, react_1.useCallback)((formData) => sendFile({
        formData,
        apiURL,
        setMessage,
        getAuthHeader,
        getAccessTokenSilently,
        loginWithRedirect,
    }), [apiURL, getAuthHeader, getAccessTokenSilently, loginWithRedirect]);
    const reset = (0, react_1.useCallback)(() => setMessage(undefined), []);
    return [send, message, reset];
};
